$(document).ready(function () {
  if ($(".e-accordion-single-holder").length > 0) {
    // scope of current accordion
    $(document)
      .find(".e-accordion-single-holder")
      .each(function (e) {
        // clicking on accordion-toggle
        var accordionTriggers = $(this).find(".e-accordion-single-item__tease");

        accordionTriggers.on("click", function (e) {
          ToggleAccordionItem($(this));
        });
      });
  }

  var params = new URLSearchParams(window.location.search);

  if (params.get("id")) {
    let item = $(
      ".e-accordion-item[data-id=" +
        params.get("id") +
        "] .e-accordion-single-item__tease"
    );

    $("html, body").animate({
      scrollTop: parseInt($(item).offset().top),
    });

    ToggleAccordionItem(item);
  }

  function ToggleAccordionItem(item) {
    //Expand or collapse this panel
    if ($(item).hasClass("open")) {
      $(item).removeClass("open");
      $(item)
        .children(
          ".e-accordion-single-item__tease .e-accordion-single-item__arrow"
        )
        .removeClass("open");
      $(item)
        .siblings(".e-accordion-single-item__content-wrapper")
        .slideUp("fast");
    } else {
      $(item).addClass("open");
      $(item)
        .children(
          ".e-accordion-single-item__tease .e-accordion-single-item__arrow"
        )
        .addClass("open");
      $(item)
        .siblings(".e-accordion-single-item__content-wrapper")
        .slideDown("fast");
    }
  }
});
